import React, { useState } from 'react';

import RenderIf from 'components/RenderIf';
import CustomProgress from 'modules/auth/components/CustomProgress';
import { Helmet } from 'react-helmet-async';
import {useTranslation} from "react-i18next";

import Table from '../home/components/VoidTicketsTable';
import Barcode from '../home/modals/Barcode';

export default function Tickets() {
  const [isLoading, setIsLoading] = useState(true);
  const [showBarcode, setShowBarcode] = useState(false);
  const [ticketInformation, setTicketInformation] = useState({});

  const {t} = useTranslation();

  return (
    <React.Fragment>
      <Helmet>
        <title>{t("MY_BRON_COUPONS")} | 1x2</title>
        <meta name="description" content={`${t("MY_BRON_COUPONS")} | 1x2`} />
      </Helmet>
      <div className="my-tickets">
        <div className="container my-tickets__container">
          <div className="my-tickets__title">
            <span>{t("MY_BRON_COUPONS")}</span>
          </div>

          <div className="wrapper-table">
            <Table
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              setShowBarcode={setShowBarcode}
              setTicketInformation={setTicketInformation}
            />
          </div>
        </div>
      </div>
      <RenderIf condition={isLoading}>
        <CustomProgress />
      </RenderIf>
      <RenderIf condition={showBarcode}>
        <Barcode
          show={showBarcode}
          onHide={setShowBarcode}
          ticketInformation={ticketInformation}
          url="voidTickets"
          enablePrint
        />
      </RenderIf>
    </React.Fragment>
  );
}
